import gql from 'graphql-tag';
import { DsrFragments } from '@getaccept/lib-shared/src/library/graphql/dsr.fragments';

export class DsrMutations {
  static createDealroom = gql`
    mutation CreateDealroom($payload: CreateDealroomPayload!) {
      createDealroom(payload: $payload) {
        id
      }
    }
  `;

  static createTemplate = gql`
    mutation CreateDsrTemplate($payload: CreateDsrTemplateInput!) {
      createDsrTemplate(payload: $payload) {
        id
        title
      }
    }
  `;

  static createDirectory = gql`
    mutation CreateDsrDirectory($payload: CreateDsrDirectoryInput!) {
      createDsrDirectory(payload: $payload) {
        ...dsrDirectoryFragment
      }
    }
    ${DsrFragments.directory}
  `;

  static updateDirectory = gql`
    mutation UpdateDsrDirectory($payload: UpdateDsrDirectoryInput!) {
      updateDsrDirectory(payload: $payload)
    }
  `;

  static deleteDirectory = gql`
    mutation DeleteDsrDirectory($id: String!) {
      deleteDsrDirectory(id: $id)
    }
  `;

  static update = gql`
    mutation UpdateDealroom($dealroomId: String!, $payload: UpdateDealroomPayload!) {
      updateDealroom(dealroomId: $dealroomId, payload: $payload)
    }
  `;

  static createEditorResource = gql`
    mutation CreateDsrEditorResource($payload: CreateDsrEditorResourceInput!) {
      createDsrEditorResource(payload: $payload) {
        ...dsrResourceFragment
      }
    }
    ${DsrFragments.resource}
  `;

  static updateResource = gql`
    mutation UpdateDsrResource($payload: UpdateDsrResourceInput!) {
      updateDsrResource(payload: $payload)
    }
  `;

  static deleteResource = gql`
    mutation DeleteDsrResource($id: String!) {
      deleteDsrResource(id: $id)
    }
  `;

  static duplicateResource = gql`
    mutation duplicateDsrResource($resourceId: String!) {
      duplicateDsrResource(resourceId: $resourceId) {
        ...dsrResourceFragment
      }
    }
    ${DsrFragments.resource}
  `;

  static useDsrTemplate = gql`
    mutation UseDsrTemplate($dsrTemplateId: String!, $name: String, $companyName: String) {
      useDsrTemplate(dsrTemplateId: $dsrTemplateId, name: $name, companyName: $companyName) {
        id
      }
    }
  `;

  static publish = gql`
    mutation Publish($dealroomId: String!, $message: String!) {
      publishDealroom(dealroomId: $dealroomId, message: $message)
    }
  `;

  static discardChanges = gql`
    mutation discardDealroomChanges($dealroomId: String!) {
      discardDealroomChanges(dealroomId: $dealroomId)
    }
  `;

  static copySampleTemplate = gql`
    mutation copyDsrSampleTemplate($templateId: String!) {
      copyDsrSampleTemplate(templateId: $templateId) {
        id
        title
      }
    }
  `;
}
